export const footer = {
    position: 'relative',
    paddingBottom: '15px',
    fontFamily: `Montserrat, sans-serif`,
  }
  export const container = {
    maxWidth: '1024px',
    width: '100%',
    margin: '0 auto',
  }
  export const content = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    zIndex: '1',
  }
  export const text = {
    fontSize: '9px',
    lineHeight: '11px',
    fontWeight: '500',
    color: '#748E8C'
  }
  export const logo = {
    margin: '0 13px'
  }